<template>
  <div class="blog w-100">
    <div class="portada-blog">
      <div class="subportada-blog d-flex align-items-center justify-content-center flex-wrap px-2">
        <div class="px-2">
          <h1 class="w-100">Noticias</h1>
          <h2>Mantente al tanto de nuestras novedades</h2>
        </div>
      </div>
    </div>
    <div class="contenedor-noticias row mx-auto w-100 py-5 bg-light">
      <div
        v-for="(item,index) in Noticias"
        :key="index"
        class="contenedor-noticia col-12 col-md-6 col-xl-4 px-md-1 px-lg-2 px-xl-3"
      >
        <img :src="item.imagen" class="img-fluid shadow" :alt="item.titulo" :title="item.titulo" />
        <div class="py-4 texto-noticia">
          <h5 class="m-0 pb-1 text-dark">{{item.titulo}}</h5>
          <span class="datos-secundarios">{{item.fecha}} - por {{item.autor}}</span>
          <p class="m-0 pb-2">{{item.subtitulo}}</p>
          <router-link
            :to="{path: '/noticia/'+ item.id}"
            class="btn btn-sm bg-dark shadow enlace"
          >Leer más</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      text: ""
    };
  },
  computed: {
    ...mapState(["Noticias", "PublicidadNoticias"])
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>
<style scoped>
.contenedor-noticias {
  padding: 0 6%;
  min-height: 50vh;
}

.portada-blog {
  height: 420px;
  width: 100%;
  min-height: 50vh;
  color: white;
  background: #262626;
  background: url("../../assets/images/portadas/noticias.jpeg");
  background-size: cover;
}

.portada-blog h1 {
  font-size: calc(3.5em + 1vh);
  letter-spacing: -1px;
}

.portada-blog h2 {
  font-size: calc(2.2em + 1vh);
}

.subportada-blog {
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
}

.texto-noticia h5 {
  font-size: 1.5em;
  font-weight: 600;
  color: #262626;
  letter-spacing: -0.3px;
}

p {
  font-weight: 500;
  color: #595959;
  letter-spacing: -0.4px;
}

h1,
h2 {
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
}

img {
  display: block;
  width: 100%;
  margin: auto;
  height: 240px;
  object-fit: cover;
}

.contenedor-noticia {
  height: 100%;
}

.enlace {
  padding: 6px 20px;
  font-size: 1em;
  color: white;
  transition: all 0.2s;
  -o-transition: all 0.2s;
  -moz-transition: all 0.2s;
  -webkit-transition: all 0.2s;
}

.enlace:hover {
  background: #262626;
  text-decoration: none;
}

.datos-secundarios {
  color: #797979;
}
</style>